//function
/**
 * slice text to lenght and
 * add ellipsis
 */
export function shorString(string, length) {
  const originalLength = string && string.length
  let shortString = string && string.slice(0, length)

  if (originalLength > length) {
    shortString += "..."
  }

  return shortString
}
